import { appInsights } from '@/telemetry/client';

export function getVimeoId(url: string) {
  const regex = /(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:[a-z]*\/)*([0-9]{6,11})[?]?.*/;
  const match = url.match(regex);
  if (match) {
    return match[1];
  }
  throw new Error(`Invalid Vimeo videoId from url: ${url}`);
}

export async function getVimeoThumb(videoId: string) {
  try {
    const response = await fetch(`https://vimeo.com/api/v2/video/${videoId}.json`);
    const data = await response.json();
    return {
      thumbnail: data[0]['thumbnail_small'],
      original: data[0]['thumbnail_large']
    };
  } catch (error) {
    throw error;
  }
}

// Example usage

export async function getVimeoUrls(videoUrl: string) {
  try {
    const videoId = getVimeoId(videoUrl);
    const thumbnailUrls = await getVimeoThumb(videoId);
    return thumbnailUrls;
  } catch (error) {
    // @ts-expect-error: Error typings
    appInsights.trackException({ exception: error });
  }
}
